import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  PaymentReq,
  PaymentRes,
  PaymentStatReq,
  PaymentStatRes,
  TopSaleReq,
  TopSaleRes,
  SupplierDashboardReq,
  SupplierDashboardRes,
  ReturnDashboardReq,
  ReturnDashboardRes,
  TerminalProfitReq,
  TerminalProfitRes,
} from './types'

export const getPaymentDashboardAction = createAsyncAction(
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_REQ',
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_SUCCESS',
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_FAILURE',
)<PaymentReq, PaymentRes, Error>()

export const getPaymentStatDashboardAction = createAsyncAction(
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_STAT_REQ',
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_STAT_SUCCESS',
  'DASHBOARD/GET_DASHBOARD_PAYMENTS_STAT_FAILURE',
)<PaymentStatReq, PaymentStatRes, Error>()

export const getTopSaleDashboardAction = createAsyncAction(
  'DASHBOARD/GET_DASHBOARD_TOPSALE_REQ',
  'DASHBOARD/GET_DASHBOARD_TOPSALE_SUCCESS',
  'DASHBOARD/GET_DASHBOARD_TOPSALE_FAILURE',
)<TopSaleReq, TopSaleRes, Error>()

export const getSupplierDashboardAction = createAsyncAction(
  'DASHBOARD/GET_SUPPLIER_DASHBOARD_REQ',
  'DASHBOARD/GET_SUPPLIER_DASHBOARD_SUCCESS',
  'DASHBOARD/GET_SUPPLIER_DASHBOARD_FAILURE',
)<SupplierDashboardReq, SupplierDashboardRes, Error>()

export const getReturnSummaryDashboardAction = createAsyncAction(
  'DASHBOARD/GET_RETURN_DASHBOARD_REQ',
  'DASHBOARD/GET_RETURN_DASHBOARD_SUCCESS',
  'DASHBOARD/GET_RETURN_DASHBOARD_FAILURE',
)<ReturnDashboardReq, ReturnDashboardRes, Error>()

export const getTerminalProfitAction = createAsyncAction(
  'DASHBOARD/GET_DASHBOARD_TERMINAL_PROFIT_REQ',
  'DASHBOARD/GET_DASHBOARD_TERMINAL_PROFIT_SUCCESS',
  'DASHBOARD/GET_DASHBOARD_TERMINAL_PROFIT_FAILURE',
)<TerminalProfitReq, TerminalProfitRes, Error>()

export const clearEventAction = createStandardAction('DASHBOARD/CLEAR_EVENT')<void>()
